import "./BusinessAutomations.module.css";
import Header from "@/reusable_sections/Header";
import Automation from "./sections/Automation";
import Workflow from "./sections/Workflow";
import Ecosystem from "./sections/Ecosystem";
import Footer from "@/reusable_sections/Footer";
export default function BusinessAutomationsPage() {
  return <div>
      <Header />
      <Automation />
      <Workflow />
      <Ecosystem />
      <Footer />
    </div>;
}